exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination[data-v-34b6b56c]{display:flex;justify-content:flex-end;align-items:center\n}\n.pagination .page-indicator[data-v-34b6b56c]{padding:0 10px\n}", ""]);

// exports
